import QuestionBlock from "../components/QuestionBlock";
import SectionCard from "../components/SectionCard";
import "../styles/style.css";

export default function Step5({ data, onChange, onNext, onBack }) {

  const isValid =
    data.deficienteResidencia &&
    data.teaResidencia &&
    data.coletaLixo &&
    data.ruaPavimentada;


  return (
    <>
    <SectionCard
          title="Condições de Moradia"
          description="Responda às perguntas abaixo com atenção. Suas respostas são confidenciais e serão utilizadas exclusivamente para fins educacionais."
          items={[
            { icon: "bi bi-building", text: "Escola Mun. Gov. Moura Cavalcanti" }
          ]}
        > </SectionCard>

      <QuestionBlock
        name="deficienteResidencia"
        title="Há alguém com deficiência na sua residência?"
        subtitle="(Resposta única)"
        options={[
          "Não",
          "Sim, deficiência física",
          "Sim, deficiência intelectual ou mental",
          "Sim, deficiência visual ou auditiva"
        ]}
        selected={data.deficienteResidencia}
        onSelect={(value) => onChange({ deficienteResidencia: value })}
      />
        <QuestionBlock
        name="teaResidencia"
        title="Há alguém com Transtorno do Espectro Autista (TEA) na sua residência?"
        subtitle="(Resposta única)"
        options={[
          "Não",
          "Sim, leve",
          "sim, moderado",
          "sim, severo"
        ]}
        selected={data.teaResidencia}
        onSelect={(value) => onChange({ teaResidencia: value })}
      />
      <QuestionBlock
        name="coletaLixo"
        title="Tem coleta de lixo na sua rua?"
        subtitle="(Resposta única)"
        options={[
          "Sim",
          "Não"
        ]}
        selected={data.coletaLixo}
        onSelect={(value) => onChange({ coletaLixo: value })}
      />
<QuestionBlock
        name="ruaPavimentada"
        title="A rua em que você vive é pavimentada?"
        subtitle="(Resposta única)"
        options={[
          "Sim",
          "Não"
        ]}
        selected={data.ruaPavimentada}
        onSelect={(value) => onChange({ ruaPavimentada: value })}
      />
      <div className="nav-buttons">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>

          <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!isValid}
        >
          Próximo
        </button>
      </div>
    </>
  );
}
